import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';
import moment from 'moment';
import styles from './PolicyRate.module.scss';
import Rate from './Rate';

const PolicyRate = ({ rate, policy }) => {
	return rate ? (
		<Segment className={styles.container}>
			<p>
				Current Policy Period: {moment(policy.effective).format('L')} - {moment(policy.expiration).format('L')}
			</p>
			<p>
				<Rate rate={rate} />
			</p>
		</Segment>
	) : null;
};

PolicyRate.propTypes = {
	rate: PropTypes.object,
	policy: PropTypes.object.isRequired,
};

export default PolicyRate;
